import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '../../services/configuration.service';
import { Branch } from './branc.model';

@Injectable({
  providedIn: 'root'
})
export class BranchesService {
  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {
  }

  save(branch: Branch) {
    return this.http.post(this.configurations.apiAddress + "/api/Branch/save", branch);
  }

  search(searchText: string) {
    let myParams = new HttpParams()
      .set('searchText', searchText == undefined ? "" : searchText)
    return this.http.get(this.configurations.apiAddress + '/api/Branch/search', { params: myParams });
  }

  delete(id: number) {
    return this.http.delete(this.configurations.apiAddress + '/api/Branch/delete/' + id);
  }

  getById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/Branch/getById/' + id);
  }

  getAll() {
    return this.http.get(this.configurations.apiAddress + '/api/Branch/getAll/');
  }
}
